import { DELETE, GET, POST, PUT } from "./_config";

//user
export const getBlogData = async (query) => await GET(`/blogs?${query || ""}`);

export const getBlogDataById = async (id) =>
  await GET(`/blogs/get-blogs/${id}`);

//admin
export const createBlogData = async (body) => await POST("/blogs/", body, true);

export const getBlogDataList = async (query) =>
  await GET(`/blogs/list?${query || ""}`, true);

export const updateBlogsStatus = async (body) =>
  await POST("/blogs/update-status", body, true);

export const deleteBlogById = async (id) =>
  await DELETE(`/blogs?id=${id}`, true);

export const getBlogById = async (id) => await GET(`/blogs/${id}`, true);

export const updateBlogDataById = async (id, body) =>
  await PUT(`/blogs?id=${id}`, body, true);
